module.exports = __webpack_public_path__ + "img/blog-65.d24476f3.jpg";